import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterFuelProductsOnlySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.FuelProductsOnly]}
      value={Number(filters[DashboardFilters.FuelProductsOnly]?.value).toString()}
      options={[{ label: 'Sim', value: '1' }, { label: 'Não', value: '0' }]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.FuelProductsOnly]: value }))}
    />
  );
}

export default DashboardFilterFuelProductsOnlySheet;
